module.exports = __webpack_public_path__ + "img/20200614_110937.e5dc174b.jpg";